import React from 'react';
import AccordionStyled from '@components/AccordionStyled';
import ManagePrice from './ManagePrice';
import ManageAllergans from './ManageAllergans';

export default function({
  currentState,
  taxRates,
  selectedTaxRate,
  handleChangeInput,
  handleTaxRateChange,
}) {
  const allergens = currentState?.product?.allergens;

  const data = [
    {
      id: 'price-panel',
      title: 'Price',
      subtitleChip: `
        € ${currentState?.priceIncludingTax?.toFixed(2)} 
        (€ ${currentState?.priceExcludingTax?.toFixed(2)} ex. vat)
      `,
      defaultExpanded: false,
      ComponentDetails: (
        <ManagePrice
          taxRates={taxRates}
          handleTaxRateChange={handleTaxRateChange}
          currentState={currentState}
          selectedTaxRate={selectedTaxRate}
          handleChangeInput={handleChangeInput}
        />
      ),
    },
    {
      id: 'allergens-panel',
      title: 'Allergens',
      subtitleChip: allergens?.length || 0,
      defaultExpanded: false,
      ComponentDetails: (
        <ManageAllergans
          allergens={allergens || []}
          handleChangeInput={handleChangeInput}
        />
      ),
    },
  ];
  return (
    <AccordionStyled
      data={data}
      defaultExpanded=""
      styleRoot={{}}
      styleAccordionDetails={{}}
    />
  );
}
